import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Home, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const AccountDeletedPage = () => {
  return (
    <>
      <SEO
        title="Compte supprimé — Puzzle Video"
        description="Confirmation de la suppression de votre compte client Puzzle Video conformément au RGPD."
        noindex
      />
      <div
        className="max-w-2xl mx-auto px-4 py-16 md:py-24"
        data-testid="account-deleted-page"
      >
        <div className="border border-border p-8 md:p-12 space-y-6 text-center">
          <div className="flex justify-center">
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
              <CheckCircle2 className="w-9 h-9 text-green-600" strokeWidth={2.2} />
            </div>
          </div>

          <h1 className="text-2xl md:text-3xl font-bold" data-testid="account-deleted-title">
            Votre compte a bien été supprimé
          </h1>

          <p className="text-muted-foreground">
            Conformément au Règlement Général sur la Protection des Données (RGPD),
            l'ensemble de vos données personnelles a été effacé de nos serveurs.
          </p>

          <div className="text-left border-t border-border pt-6 space-y-3 text-sm">
            <p className="font-semibold">Ce qui a été supprimé :</p>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>Votre profil (nom, email, téléphone, entreprise)</li>
              <li>Vos demandes de devis et l'historique associé</li>
              <li>Vos projets et paniers enregistrés</li>
              <li>Vos sessions actives (déconnexion immédiate)</li>
            </ul>
          </div>

          <div className="text-left border-t border-border pt-6 space-y-3 text-sm text-muted-foreground">
            <p>
              <strong className="text-foreground">Devis passés définitivement anonymisés :</strong>{' '}
              pour des raisons comptables et légales, les factures et devis facturés
              peuvent être conservés de façon anonymisée pendant la durée légale
              (10 ans en France).
            </p>
            <p>
              <strong className="text-foreground">Une question ?</strong>{' '}
              Contactez-nous à{' '}
              <a
                href="mailto:contact@puzzlevideo.fr"
                className="text-primary hover:underline"
                data-testid="account-deleted-contact-link"
              >
                contact@puzzlevideo.fr
              </a>
              .
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
            <Link to="/">
              <Button className="rounded-none w-full sm:w-auto" data-testid="account-deleted-home-btn">
                <Home className="w-4 h-4 mr-2" /> Retour à l'accueil
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="rounded-none w-full sm:w-auto">
                <Mail className="w-4 h-4 mr-2" /> Nous contacter
              </Button>
            </Link>
          </div>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-6">
          Merci de votre confiance et à bientôt chez Puzzle Video.
        </p>
      </div>
    </>
  );
};

export default AccountDeletedPage;
